<template>
<div>
	<div class="info-detail-one-prop" v-if="detailsOne">
    <div class="close iconfont icon-close" @click="()=>{$emit('hide')}"></div>
		<div class="info_detail_wrap" ref="newsOne" @scroll="listScroll">
			<div class="info-detail">
				<div class="info-title">{{detailsOne.title}}</div>
				<div class="info-source">
					<p class="date">{{detailsOne.pub_time}}</p>
					<p class="from" v-if="detailsOne.source">来源：{{detailsOne.source}}</p>
					<p class="author" v-if="detailsOne.author">作者：{{detailsOne.author}}</p>
					<p class="author" v-if="detailsOne.modifier">责任编辑：{{detailsOne.modifier}}</p>
					<!-- <p class="readNum">{{detailsOne.lookcount}}次浏览</p> -->
					<p class="font-style" v-if="false">
						字号：
						<em class="small" :class="{'active':index==1}" @click="changeSize('x-small',1)">小</em>
						<em class="medium" :class="{'active':index==2}" @click="changeSize('medium',2)">中</em>
						<em class="large" :class="{'active':index==3}" @click="changeSize('x-large',3)">大</em>
					</p>
				</div>
				<div class="intro-video" v-if="detailsOne.media_path ">
					<div class="video-box" v-if=" detailsOne.media_path.indexOf('mp3')< 0">
						<div class="video-cover" @click="playVideo" v-if="videoCoverShow">
							<img v-if="detailsOne.cover_img" :src="showpath + detailsOne.cover_img" class="cover-img" />
							<!-- <img v-else src="../images/video-cover11.jpg" class="cover-img" /> -->
							<div class="play_btn">
								<span class="iconfont icon-play"></span>
							</div>
						</div>
						<!-- <img src="images/video.jpg" alt=""> -->
						<video id="video" :src="showpath + detailsOne.media_path" controls
							controlslist="nodownload"></video>
					</div>
					<div class="video-box isAudio" v-else>
						<audio controls controlslist="nodownload">
							<source :src="showpath + detailsOne.media_path">
						</audio>
					</div>
				</div>
				<div class="info-introduce">
					<div class="introduce" v-html="detailsOne.content"></div>
				</div>
			</div>
		</div>
	</div>
  <div class="back-top" @click="goTop($event)" v-if="goTopShow">
    <span class="iconfont icon-top"></span>
  </div>
</div>
</template>
<script>
	export default {
		components: {
		},
		name: '',
		props: {
		},
		data() {
			return {
				Size: {
					fontSize: ""
				},
				index: 2,
				videoCoverShow: true,
				detailsOne: null,
				showpath: null,
        goTopShow: false,
        elementTop: 0,
			}
		},
		mounted() {
			this.getList();
		},
		computed: {
		},
		methods: {
			playVideo() {
				var video = document.getElementById("video");
				video.play();
				this.videoCoverShow = false;
			},
    	// 获取攻略
    	getList(){
    	  this.$api.newsApi.getList().then((res)=>{
    	  if(res && res.code==0){
			  if(!this.showpath) this.showpath = res.showpath;
			  res.data.pub_time = res.data.pub_time&&res.data.pub_time.split(/ /)[0];
    	    	this.detailsOne = res.data;
    	    }else{
    	      this.$toast.fail(res.msg)
    	    }
			  });
    	},
      listScroll(e){
        let scrollTop =  e.target.scrollTop   // 滚动距离
        if(scrollTop>500){
          this.goTopShow = true;
        }else{
          this.goTopShow = false;
        }
      },
      goTop(){
        this.$refs.newsOne.scrollTop = 0;
      }
		},
	}
</script>
<style scoped lang="scss">
.info-detail-one-prop {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: #fff;
  .info_detail_wrap {
    height: 100%;
    overflow: auto;
  }
  .icon-close {
    position: absolute;
    right: 0rem;
    top: 0rem;
    padding: 10rem;
    font-size: 18rem;
    z-index: 6;
  }
}
// 回到顶部
.back-top {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  right: 15rem;
  border-radius: 4rem;
  bottom: 50rem;
  z-index: 6;
  width: 40rem;
  height: 40rem;
  color: #fff;
  line-height: 45rem;
  text-align: center;
  span {
    color: #fff;
    font-size: 20rem;
    line-height: 2;
  }
}
// 内容页
.info_detail_wrap{
  .info-detail {
    width: 100%;
    padding: 30rem;
    box-sizing: border-box;
    .info-title {
      font-size: 18rem;
      font-weight: bold;
      color: #222;
      line-height: 1.8;
      margin-bottom: 15rem;
      &.info-title-left {
        text-align: left;
      }
    }
    .info-source {
      display: flex;
      align-items: center;
      font-size: 12rem;
      color: #666;
      padding-bottom: 15rem;
      border-bottom: 1rem solid #eee;
      position: relative;
      p {
        margin-right: 15rem;
        line-height: 16rem;
        &.addr {
          font-size: 14fem;
        }
        em {
          margin-right: 8rem;
        }
        &.font-style {
          position: absolute;
          right: 0;
          .active {
			font-weight: bold;
			color: #222;
          }
          em {
            cursor: pointer;
          }
        }
      }
      &.info-source-left {
        justify-content: flex-start;
      }
    }
    .info-bianji {
      width: 100%;
      text-align: right;
      font-size: 12rem;
      color: #666;
      line-height: 20rem;
    }
	.info-introduce {
      padding-top: 15rem;
      width: 100% !important;
      color: #222;
      line-height: 24rem !important;
	}
	  .introduce {
      	width: 100% !important; 
      &.info-introduce-falv {
        padding-top: 0;
      }
      p {
        width: 100% !important;
        font-size: 16rem;
        margin-bottom: 8rem;
        line-height: 1.8;
        text-indent: 2em;
        text-align: justify;
      }
  
      div {
        width: 100% !important;
      }
  
      img {
        max-width: 100%;
        display: block;
        margin: 0 auto;
        border-radius: 4rem;
      }
  
      video {
        width: 100%;
        height: auto;
        overflow: hidden;
        border-radius: 4rem;
        padding: 20rem 0;
      }
      div,
      p,
      h1,
      h2,
      h3,
      h4,
      h5,
      span,
      td,
      section,
      figure,
      iframe, 
      a {
        font-family: 'Source Han Sans CN',Arial,Helvetica,sans-serif !important;
        // font-size: 16rem !important;
        margin-bottom: 10rem !important;
        line-height: 1.8em !important;
        text-indent: 2em !important;
        text-align: justify !important;
        margin: 0 0 10rem !important;
        letter-spacing: 0 !important;
        background: none !important;
        padding: 0 !important;
        width: auto !important;
        color: #222 !important;
        word-wrap: break-word !important;
        word-break: break-all !important;
        border: none !important;
        box-shadow: none !important;
        height: auto !important;
      }
      div.nosuo,
      p.nosuo,
      h1.nosuo,
      h2.nosuo,
      h3.nosuo,
      h4.nosuo,
      h5.nosuo,
      span.nosuo,
      td.nosuo,
      section.nosuo,
      figure.nosuo, 
      iframe.nosuo, 
      a.nosuo {
        text-indent: 0 !important;
      }
      
      section, 
      p, 
      div {
        display: block !important;
      }
      
      span {
        background: none !important;
      }
      
      img {
        max-width: 100% !important;
        height: auto !important;
        padding: 0 !important;
        margin: 0 !important;
        display: block;
        margin: 0 auto !important;
      }
      
      .info-introduce table {
        width: 100% !important;
      }
    }
    .content-sbox{
      margin-bottom: 18rem;
      .sbox-title{
        font-size:14rem;
        color: #01b37e;
        font-weight: bold;
        border-left: 4rem solid #01b37e;
        margin-bottom: 10rem;
        padding-left:10rem;
        line-height: 1;
      }
      .sbox-content{
        padding-left: 15rem;
        text-align: justify;
      }
    }
    .introduce-means {
      margin-top: 16rem;
      .int-item {
        color: #222;
        font-size: 16rem;
        margin-bottom: 10rem;
        em {
          display: inline-block;
          color: #666;
          margin-right: 8rem;
          min-width: 64rem;
          text-align: justify;
          text-align-last: justify;
        }
        &.large_active em {
          min-width: 100rem;
        }
        }

    }
  }
  .info-pagination{
    width: 100%;
    padding: 15rem 30rem;
    font-size: 12rem;
    color: #222;
    border-top: 1rem solid #666;
    box-sizing: border-box;
    .info-button {
      display: flex;
      align-items: center;
      margin-bottom: 15rem;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        color:#666;
        &.info-text {
          margin-left: 16rem;
          color: #222;
        }
      }
    }
  }
}


</style>